import CartContent from './cart-content.js';
import './svg-images-loaded-7454cac3.js';
import { E as EVENTS } from './events-58bc9098.js';

class CartPage extends CartContent {
  connectedCallback() {
    super.connectedCallback();

    // Remove free gift items from cart on page load
    this.removeFreeGiftItems();
  }
}

if (!customElements.get("cart-page")) {
  customElements.define("cart-page", CartPage);
}
